import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Button,
    Text,
} from '@chakra-ui/react';
import { PARTBAY_BLUE, PARTBAY_BLUE_HOVER } from '../../../../components/settings/primitives';

export interface ProhibitedVendorAlertDialogProps {
    isOpen: boolean;
    leastDestructiveRef: React.RefObject<HTMLButtonElement>;
    onConfirm: () => void;
}

/**
 * Shown after saving when the server flags that a vendor was prohibited for a
 * DRP location, so the acknowledgement is recorded before the flow closes.
 * Dismissal is the only way out, which is why it stays a dialog rather than
 * becoming part of the vendor screen.
 */
const ProhibitedVendorAlertDialog = ({
    isOpen,
    leastDestructiveRef,
    onConfirm,
}: ProhibitedVendorAlertDialogProps) => (
    <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={leastDestructiveRef}
        onClose={onConfirm}
        closeOnOverlayClick={false}
        closeOnEsc={false}
        isCentered
        size="xl"
    >
        <AlertDialogOverlay>
            <AlertDialogContent maxW="640px" overflow="hidden">
                <AlertDialogHeader
                    bg="gray.100"
                    borderBottom="1px solid"
                    borderColor="gray.300"
                    color="gray.800"
                    fontSize="xl"
                    fontWeight="semibold"
                    px={6}
                    py={4}
                >
                    Prohibited Vendor
                </AlertDialogHeader>

                <AlertDialogBody px={6} py={5}>
                    <Text fontSize="md" color="gray.700" lineHeight="1.7">
                        For DRPs, this will result in an increase in missed opportunities. You
                        confirm that every time this vendor is the most-cost effective option that we
                        will neither price match to it nor select it.
                    </Text>
                </AlertDialogBody>

                <AlertDialogFooter
                    bg="gray.50"
                    borderTop="1px solid"
                    borderColor="gray.300"
                    px={6}
                    py={4}
                >
                    <Button
                        size="action"
                        ref={leastDestructiveRef}
                        bg={PARTBAY_BLUE}
                        color="white"
                        _hover={{ bg: PARTBAY_BLUE_HOVER }}
                        onClick={onConfirm}
                    >
                        Confirm
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialogOverlay>
    </AlertDialog>
);

export default ProhibitedVendorAlertDialog;
